import React from "react";
import { InlineWidget } from "react-calendly";
import "./ScheduleCall.css";
import ContactSection from "../Contact/Contact";

const CustomScheduleCall = () => {
  return (
    <ContactSection/>
  );
};

export default CustomScheduleCall;
